import type {Occasion} from './domain';
export const occasionLabels:Record<Occasion,string>={birthday:'생일',thanks:'감사',housewarming:'집들이',celebrate:'축하',comfort:'위로',holiday:'명절',farewell:'퇴사·이직',anniversary:'결혼기념일'};
